import { Component, Injector, Input } from '@angular/core';
import { TableDummiesWidgetBaseComponent } from '../table-dummies-widget-base/table-dummies-widget-base';

/**
 * TableDummies2Full Widget
 */
@Component({
  selector: 'table-dummies2-full-widget',
  templateUrl: './table-dummies2-full-widget.component.html',
  styleUrls: ['../../common/css/general.scss', '../table-dummies-widget-base/table-dummies-widget-base.scss']
})
export class TableDummies2FullWidgetComponent extends TableDummiesWidgetBaseComponent {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'tableDummies2Full');
  }
}
